import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { buildWhatsAppLink } from "@/lib/api";

export default function WhatsAppFAB({ message }) {
  const { pathname } = useLocation();
  // On mobile, hide the FAB on package detail pages (they have a sticky action bar).
  const hideOnMobile = /^\/packages\/[^/]+$/.test(pathname);
  return (
    <a
      href={buildWhatsAppLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      className={`wa-btn fixed bottom-6 right-6 z-50 rounded-full p-4 flex items-center gap-2 ${
        hideOnMobile ? "hidden lg:flex" : ""
      }`}
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-6 h-6" strokeWidth={1.6} />
      <span className="hidden sm:inline text-sm font-medium pr-1">
        Chat on WhatsApp
      </span>
    </a>
  );
}
